<template>
  <div id="contenedor-agregar-nuevo-cliente">
    <v-form v-model="formularioValido" ref="registrarNuevoCliente">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo Cliente
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-field
            label="Nombre del Cliente"
            v-model="cliente.nombre"
            :rules="[mixReglas.requerido]"
            required
          >
          </custom-text-field>

          <template v-if="!rutaArchivo">
            <v-row justify="center">
              <div
                class="contenedor-imagen-agregar"
                @click="$refs.seleccionarAnexo.click()">
                <v-img
                  src="@/assets/add-img-img.png"
                  contain
                  height="100"
                  width="100">
                </v-img>
              </div>
            </v-row>
          </template>

          <template v-if="rutaArchivo">
            <v-row justify="center">
              <v-img
                :src="rutaArchivo"
                height="300"
                width="300"
                contain
                class="blue-grey darken-4">
                <div class="contenedor-imagenes-remover-imagen">
                  <v-btn
                    small
                    icon
                    dark
                    @click="$refs.seleccionarAnexo.click()">
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </div>
              </v-img>
            </v-row>
          </template>

        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="guardarLogo"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
      <input
        type="file"
        ref="seleccionarAnexo"
        id="anexo"
        class="d-none"
        accept="image/jpeg, image/png, image/bmp"
        capture="camera"
        @change="seleccion">
    </v-form>
  </div>
</template>

<script>
import mixCatalogoClientes from './mixCatalogoClientes';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixSubirArchivo from '@/helpers/mixSubirArchivo';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'CatalogosClientesNuevo',
  mixins: [mixCatalogoClientes, mixSubirArchivo],
  components: {
    CustomTextField,
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      cliente: {
        nombre: '',
        logo: '',
      },
      date: '',
      menu: false,
      rutaArchivo: null,
    };
  },
  mounted() {
    eventBus.$on('seCargoArchivo', (archivo) => {
      this.cliente.logo = archivo.data.public_key;
    });
  },
  methods: {
    async guardarLogo() {
      // si existe una ruta de archivo, se sube el archivo al servidor
      // this.enviandoFormulario = true;
      if (this.rutaArchivo) {
        const datosArchivo = this.setDatosArchivo();
        await this.mixSubirArchivo(datosArchivo);
      }
      await this.mixAgregarCliente();
    },
    setDatosArchivo() {
      const datosArchivo = {
        nombre: 'logo',
        path: '/',
      };
      return datosArchivo;
    },
    seleccion() {
      this.formularioValido = true;
      this.rutaArchivo = URL.createObjectURL(
        document.getElementById('anexo').files[0],
      );
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    limpiarFormulario() {
      this.$refs.registrarNuevoCliente.reset();
    },
  },
};
</script>
<style lang="scss" scoped>
.contenedor-imagenes-remover-imagen {
  position: absolute;
  top: 5px;
  right: 5px;
}
.contenedor-imagen-agregar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  height: 180px;
  width: 180px;
  padding: 1em;
  border-radius: .5rem;
  cursor: pointer;
}
.contenedor-imagen-agregar:hover {
  border: 2px solid #ccc;
}
</style>
